import { rememberProductTourReturnPath } from './product-tour-return';
import { rememberProductTourEntryPoint } from '../analytics/product-tour-analytics';
import type { ProductTourAnalyticsEntryPoint } from '../../product-guidance/types/product-guidance';

export const GUIDED_PRODUCT_TOUR_PATH = '/tour?guided=1';

/**
 * Permanent Product Tour entry points use one stable action. The tour runtime
 * decides whether the person should START, RESUME, or REPLAY from durable state.
 */
export function launchGuidedProductTour(
  returnPath: string,
  navigate: (to: string) => void,
  entryPoint: ProductTourAnalyticsEntryPoint = 'DIRECT',
): void {
  rememberProductTourReturnPath(returnPath);
  rememberProductTourEntryPoint(entryPoint);
  navigate(GUIDED_PRODUCT_TOUR_PATH);
}
